;(() => {
  function getRoomId(str) {
    return str.match(/#room-(\d+)/)[1]
  }

  const GROUPS_CONTAINER_SELECTOR = ".rooms-groups"

  function isMultiGroup() {
    return document.querySelector(GROUPS_CONTAINER_SELECTOR)
  }

  function openRoom(parent, $roomLink) {
    const roomId = getRoomId($roomLink.attr("href"))
    $(parent).find(`.rooms-i[data-id^='${roomId}']`).trigger("click")
  }

  $(document).on("click", 'a[href^="#room-"]', function clickHandler(event) {
    event.preventDefault()
    const $roomLink = $(this)

    if (isMultiGroup()) {
      const firstUnselectedGroup = document.querySelector(
        ".rooms-group_expanded",
      )
      if (firstUnselectedGroup) {
        openRoom(firstUnselectedGroup, $roomLink)
      } else {
        Viewport.scrollTo($(GROUPS_CONTAINER_SELECTOR))
      }
    } else {
      openRoom(document, $roomLink)
    }
  })
})()
